import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import Card from "@mui/material/Card";
// import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import {
	adminAddUserPermission,
	getCompany,
	getUserPermission,
	updateUserPermission,
	deleteUserData, 
	resetPassword
} from "../WorkSpace/Components/ApiServices/apiHandler";
import {
	unrestrictedAccess_,
	rawCompanyData
} from "../data/rolePermissionRawData";
import { Button } from "../myfin_v2/elements/Button";
import { generatePassword } from "../helper/accessibility";
import AdminNavbar from "./Components/AdminNavbar";
import Sidebar from "../myfin_v2/elements/Sidebar";
import Modal from "../myfin_v2/elements/Modal";
import modalcss from "../myfin_v2/css/modal.module.css";
import buttoncss from "../myfin_v2/css/button.module.css";
import adminPortalCss from "../myfin_v2/css/adminportal.module.css";
import SuccessModal from "../myfin_v2/components/connections/SuccessModal";
import ErrorModal from "../myfin_v2/components/connections/ErrorModal";
import MemberCreationProgressBar from "../myfin_v2/components/adminportal/MemberCreationProgressBar";
import { ReactComponent as RightIcon } from "../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as LeftIcon } from "../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as CloseIcon } from "../myfin_v2/assets/icons/close.svg";
import DefaultCompany from "../myfin_v2/assets/imgs/defaultCompany.png";

const AdminUser = () => {
	const { childUserId, isUpdate } = useParams();
	const history = useHistory();

	const [activeCompaniesIds, setActiveCompaniesIds] = useState([]);
	const [companiesData, setCompaniesData] = useState([]);
	const [companies, setCompanies] = useState([]);
	const [unrestrictedAcessData, setUnrestrictedAcessData] = useState([]);
	const [isPermissionCreated, setIsPermissionCreated] = useState(true);

	const [displayModal, setDisplayModal] = useState(false);
	const [deleteMemberModal, setDeleteMemberModal] = useState(false);
	const [resetPasswordModal, setResetPasswordModal] = useState(false);
	const [showSuccessToaster, setShowSuccessToaster] = useState(false);
	const [successMessage, setSuccessMessage] = useState("");
	const [showErrorToaster, setShowErrorToaster] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	useEffect(() => {
		if (isUpdate) {
			getUserPermissionData();
		}
		getCompanies();
	}, []);

	const getUserPermissionData = () => {
		getUserPermission(childUserId).then(response => {
			const responseResult = response.data.result;
			if (responseResult) {
				setIsPermissionCreated(false);
				const filteredCompanyData = responseResult.companyData.map(item => {
					return { company: item.company._id, components: item.components, type: item.type, _id: item._id }
				})
				setCompaniesData(filteredCompanyData);
				setActiveCompaniesIds(responseResult.selectCompanies);
				setUnrestrictedAcessData(responseResult.unrestrictedAcessData);
			}
		}).catch(error => {
			swal(
				"Error",
				error.response?.data?.error_message || "Selected Company Data Not Found!",
				"error"
			);
		});
	}

	const getCompanies = async () => {
		getCompany().then(response => {
			setCompanies(response.data.getCompany);
		}).catch(error => {
			swal(
				"Error",
				error.response?.data?.error || "Company data get failed!",
				"error"
			);
		})
	};

	const handleButtonClick = (_id) => {
		if (activeCompaniesIds.includes(_id)) {
			setActiveCompaniesIds(prev => prev.filter(item => item !== _id));
			setCompaniesData(prev => prev.filter(item => item.company !== _id));
		} else {
			setActiveCompaniesIds([...activeCompaniesIds, _id]);
			setCompaniesData(prev => ([...prev, {
				company: _id,
				components: rawCompanyData,
				type: "single"
			}]));
		}
	};

	const SubmitSelectedCompany = () => {
		adminAddUserPermission({
			user: childUserId,
			companyData: companiesData,
			unrestrictedAcessData: unrestrictedAccess_,
			selectCompanies: activeCompaniesIds
		}).then(response => {
			toast.success("Selected Company Added Successfully.");
			history.push(`/add-responsibility/${childUserId}`);
		}).catch(error => {
			swal(
				"Error",
				error.response?.data?.error_message || "Selected Company Added Failed!",
				"error"
			);
		})
	}

	const updatePermissionData = () => {
		if (isPermissionCreated) {
			SubmitSelectedCompany();
		} else {
			updateUserPermission(childUserId, {
				userPermissionData: companiesData,
				unrestrictedAccessData: unrestrictedAcessData,
				selectCompanies: activeCompaniesIds,
				step: "selectedCompany"
			}).then(res => {
				toast.success("Selected companies updated successfully.");
				history.push(`/add-responsibility/${childUserId}`)
			}).catch(error => {
				swal(
					"Error",
					error.response?.data?.error_message || "Responsibility Updated Failed!",
					"error"
				);
			})
		}
	}

	const handleClose = () => {
        setDisplayModal(false);
    };

	const handleDeleteMember = async (userId) => {
		try {
			await deleteUserData(userId);
			handleClose();
			setDeleteMemberModal(false);
			history.push(`/admin`)

			toast.success("Team Member Deleted Successfully.");
		} catch (error) {
			toast.error(error.response?.data?.error || "Team member delete failed!");
		}
	}

	const handleResetPassword = async (userId) => {
	
		const tempPassword = generatePassword();

		await resetPassword({
			tempPassword,
			userId
		})

		handleClose();
		setResetPasswordModal(false);
		showToaster("Email Sent Sucessfully!", "success")

	}

	//Toaster

	const showToaster = (message, type) => {
		if (type === "success") {
			setSuccessMessage(message);
			setShowSuccessToaster(true);
			setTimeout(() => {
				setShowSuccessToaster(false);
				setSuccessMessage("");
			}, 3000); // Hide after 3 seconds
		} else if (type === "error") {
			setErrorMessage(message);
			setShowErrorToaster(true);
			setTimeout(() => {
				setShowErrorToaster(false);
				setErrorMessage("");
			}, 3000); // Hide after 3 seconds
		}
	};

	const handleCloseSuccessToaster = () => {
		setShowSuccessToaster(false);
		setSuccessMessage("");
	};

	const handleCloseErrorToaster = () => {
		setShowErrorToaster(false);
		setErrorMessage("");
	};
	


	return (
		<>
			<div className={adminPortalCss.dFlex}>
				<Sidebar />
				<div className={adminPortalCss.memberScreenLayout}>
					<div className={adminPortalCss.mSProgress}>
						<motion.div
							initial={{ x: -100, opacity: 0 }}
							animate={{ x: 0, opacity: 1 }}
							exit={{ x: -100, opacity: 0 }}
							transition={{ duration: 1, ease: "easeInOut" }}
							className="w-100"
						>
                        	<MemberCreationProgressBar ActiveStage={2}/>
						</motion.div>
                    </div>
					<motion.div
						initial={{ x: 100, opacity: 0 }}
						animate={{ x: 0, opacity: 1 }}
						exit={{ x: 100, opacity: 0 }}
						transition={{ duration: 1, ease: "easeInOut" }}
						className="w-100"
					>
						<div className={adminPortalCss.dataCard}>
							<span className={`${adminPortalCss.msHeadingText} ${adminPortalCss.msGdHeading}`}>Choose the companies you need access to</span>
							<div className={adminPortalCss.companiesContainer}>
								<div className={adminPortalCss.companiesCardContainer}>
									{companies.map((company, index) => (
										<div 
											className={adminPortalCss.companyCard}
											style={{
												borderColor:activeCompaniesIds.includes(company._id)
												? "#3AB67D"
												: "#EAEEED",
												background:activeCompaniesIds.includes(company._id)
												? "#F4FAF5"
												: "#F8F9F9",
											}}
											onClick={() => handleButtonClick(company._id)}
										>
											<img
												className={adminPortalCss.companyImage}
												src={ company.logo_url || DefaultCompany}
												alt="company_img"
												onError={(e) => {
													e.target.onerror = null;
													e.target.src =  DefaultCompany;
												}} 
											/>
											<span className={adminPortalCss.companyName}>{company.company_name}</span>
										</div>
										// <Button
										// 	key={index}
										// 	variant="outlined"
										// 	className="text-dark font-sans"
										// 	onClick={() => handleButtonClick(company._id)}
										// 	style={{
										// 	borderRadius: "20px",
										// 	fontSize: "12px",
										// 	border: activeCompaniesIds.includes(company._id)
										// 		? "2px solid #03565A"
										// 		: "2px solid grey",
										// 	color: activeCompaniesIds.includes(company._id)
										// 		? "#03565A"
										// 		: "black",
										// 	margin: "5px",
										// 	backgroundColor: activeCompaniesIds.includes(company._id)
										// 		? "#F8F8F8"
										// 		: "white",
										// 	textTransform: "capitalize",
										// 	}}
										// >
										// 	{company.company_name}
										// </Button>
										))}
								</div>
							</div>
						</div>
					</motion.div>
					<motion.div
						initial={{ x: -100, opacity: 0 }}
						animate={{ x: 0, opacity: 1 }}
						exit={{ x: -100, opacity: 0 }}
						transition={{ duration: 1, ease: "easeInOut" }}
						className="w-100"
					>
						<div className={adminPortalCss.footerSection}>
							<div className={adminPortalCss.footerData}>
								<button
									className={adminPortalCss.outlinedBtn}
									onClick={() => history.push(`/admin`)}
								>
									Cancel
								</button>
								<div className={adminPortalCss.footerRightBtn}>
									
									{childUserId && (
                                        <div className={adminPortalCss.dFlex}
                                            style={{gap:"20px"}}
                                        >
                                            <span
                                                style={{
                                                    color:"#E30000",
                                                    fontWeight:"500",
                                                    cursor:"pointer"
                                                }}

                                                onClick={() => {
                                                    setDisplayModal(true);
                                                    setDeleteMemberModal(true);
                                                }}
                                                
                                            >Delete Member</span>

                                            <span
                                                style={{
                                                    color:"#2D8861",
                                                    fontWeight:"500",
                                                    cursor:"pointer"
                                                }}
                                                onClick={() => {
                                                    setDisplayModal(true);
                                                    setResetPasswordModal(true);
                                                }}
                                            >
                                                Reset Password
                                            </span>
                                        </div>
                                    )}

									<button
										className={adminPortalCss.outlinedBtn}
										onClick={() => history.push(`/add-teamate/${childUserId}`)}
									>
										<LeftIcon /> &nbsp; Previous
									</button>
									<button
										className={adminPortalCss.primaryBtn}
										onClick={() => {
											if(isUpdate) {
												updatePermissionData();
											}else{
												SubmitSelectedCompany();
											} 
										}}
									>
									Next <RightIcon />
									</button>
									
								</div>
							</div>
						</div>
					</motion.div>
					{deleteMemberModal && displayModal && (
						<Modal
						headerActions={
							<CloseIcon
							onClick={() => {
								handleClose();
								setDeleteMemberModal(false);
							}}
							className="clickable"
							/>
						}
						headerBottomLine={false}
						onClose={() => console.log("Modal Closed")}
						>
						<span className={`${modalcss.modalBodyHead} mb-1`}>
							Do you want to <span className="fw700">delete</span> the
							member?
						</span>
						<span
							className={`${modalcss.modalBodycnt}`}
							style={{ "margin-bottom": "35px" }}
						>
							You can restore the deleted members
						</span>
						<span
							className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
						>
							<Button
							btnColor={buttoncss.danger}
							label="Yes, Delete"
							onClick={() => {
								handleDeleteMember(childUserId);
							}}
							/>
							<Button
							btnColor={buttoncss.secondary_del}
							label="No, Cancel"
							onClick={() => {
								handleClose();
								setDeleteMemberModal(false);
							}}
							/>
						</span>
						</Modal>
					)}
					{resetPasswordModal && displayModal && (
						<Modal
							headerActions={
							<CloseIcon
								onClick={() => {
									handleClose();
									setDeleteMemberModal(false);
								}}
							className="clickable"
							/>
						}
						headerBottomLine={false}
						onClose={() => console.log("Modal Closed")}
						>
						<span className={`${modalcss.modalBodyHead} mb-1`}>
							Reset Password?
						</span>
						<span
							className={`${modalcss.modalBodycnt}`}
							style={{ "margin-bottom": "35px" }}
						>
							A temporary password will be sent to your email to reset your password. Your old password won’t be valid anymore
						</span>
						<span
							className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
						>
							<Button
							btnColor={buttoncss.secondary_del}
							label="Cancel"
							onClick={() => {
								handleClose();
								setResetPasswordModal(false);
							}}
							/>
							<Button
								btnColor={buttoncss.primary}
								label="Proceed"
								onClick={() => {
									handleResetPassword(childUserId);
								}}
							/>
						</span>
						</Modal>
					)}

					{showSuccessToaster && (
						<SuccessModal
							handleClose={handleCloseSuccessToaster}
							setSuccessModal={setShowSuccessToaster} 
							setSuccessMessage={setSuccessMessage} 
							successMessage={successMessage}
							bodycls=""
						/>
					)}
		
					{showErrorToaster && (
						<ErrorModal
							handleClose={handleCloseErrorToaster}
							setErrorModal={setShowErrorToaster} 
							setErrorMessage={setErrorMessage}
							errorMessage={errorMessage}
						/>
					)}
				</div>
			</div>
			{/* <AdminNavbar />
      <div className="px-4 py-3">
        <Card className="w-100 radius-12px">
          <div className="px-3 py-3">
            <div>
              <p className="mt-0 mb-0 font-size-18 custom-font-600 font-sans ">
                Add Teamate
              </p>
              <p className="mt-0 mb-2 font-size-16 custom-font-500 font-sans">
                Fill out all the requirements to create new Teammate
              </p>
            </div>
            <div className="mt-3 general-box">
              <div className="d-flex flex-wrap p-2">
                <div className="d-flex justify-content-center align-items-center mt-1 Primary-circle">
                  <CheckIcon className="text-white" />
                </div>
                <div className="flex-grow-1">
                  <p className="mt-2 p-1 mb-0 font-size-12 custom-font-600 font-sans custom-common-theme-text-color">
                    General Details
                    <span className="text-secondary">
                      -------------------------------------------------------
                    </span>
                  </p>
                </div>
                <div className="d-flex justify-content-center align-items-center mt-1 orange-circle">
                  <p className="mt-0 mb-0 font-size-12 custom-font-600 font-sans">
                    2
                  </p>
                </div>
                <div className="flex-grow-1">
                  <p
                    className="mt-2 p-1 mb-0 font-size-12 custom-font-600 font-sans"
                    style={{ color: "brown" }}
                  >
                    Select Companies
                    <span className="text-secondary">
                      -------------------------------------------------------
                    </span>
                  </p>
                </div>
                <div
                  className="d-flex justify-content-center align-items-center mt-1 white-circle"
                  style={{
                    border: "1px solid #8692A6",
                  }}
                >
                  <p className="mt-0 mb-0 font-size-12 custom-font-600 font-sans">
                    3
                  </p>
                </div>
                <div className="flex-grow-1">
                  <p className="mt-2 p-1 mb-0 font-size-12 custom-font-600 font-sans text-secondary">
                    Responsibilities
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-3 px-2 py-2 radius-8px border border-secondary">
              <p className="mt-0 mb-0 font-size-16 custom-font-600 custom-common-theme-text-color font-sans">
                Induvial Entities
              </p>
              <div
                className="mt-2"
                style={{ maxHeight: "150px", overflowY: "auto" }}
              >
                {companies.map((company, index) => (
                  <Button
                    key={index}
                    variant="outlined"
                    className="text-dark font-sans"
                    onClick={() => handleButtonClick(company._id)}
                    style={{
                      borderRadius: "20px",
                      fontSize: "12px",
                      border: activeCompaniesIds.includes(company._id)
                        ? "2px solid #03565A"
                        : "2px solid grey",
                      color: activeCompaniesIds.includes(company._id)
                        ? "#03565A"
                        : "black",
                      margin: "5px",
                      backgroundColor: activeCompaniesIds.includes(company._id)
                        ? "#F8F8F8"
                        : "white",
                      textTransform: "capitalize",
                    }}
                  >
                    {company.company_name}
                  </Button>
                ))}
              </div>
            </div>
            
            <div className="d-flex justify-content-end mt-4" style={{gap:"10px"}}>
              <Button 
                variant="contained" 
                style={{ width:"330px",height:"50px" }} 
                className="bg-white custom-common-theme-text-color primary-border radius-10px font-size-16 custom-font-500 text-capitalize font-sans" 
                onClick={() => history.push("/add-teamate")}
              >
                Back
              </Button>
              <Button 
                variant="contained" 
                style={{ width:"330px",height:"50px" }} 
                className="custom-common-theme-bg-color radius-10px font-size-16 custom-font-500 text-capitalize font-sans" 
                onClick={() => {
                  if(isUpdate) {
                    updatePermissionData();
                  }else{
                    SubmitSelectedCompany();
                  } 
                }}
              >
                Next
              </Button>
            </div>
          </div>
        </Card>
      </div> */}
		</>
	);
};

export default AdminUser;
